import React from "react"
import { createPortal } from "react-dom"

import "./styles.scss"

let tooltipEle = null
export default function Tooltip(props) {
  const { country, x, y, scoreKey } = props
  if (!tooltipEle) {
    tooltipEle = document.querySelector("#tooltip")
    if (!tooltipEle) {
      console.warn("tooltip element not found?")
    }
  }

  const score = country[scoreKey]

  const tooltipStyle = {
    left: x,
    top: y,
    transform: `translate(-50%, -100%)`,
  }

  return createPortal(
    <div className="countryFactorFillGraphTooltip" style={tooltipStyle}>
      {country.Country} {score === null ? "N/A" : score.toFixed(2)}
    </div>,
    tooltipEle,
  )
}
